import { EquivBugState } from "../lib/workflow/workflow-manager-constants";
import { BugStateGeneratedEntity } from "./generated/BugStateGeneratedEntity";

const OPEN_STATES = new Set<number>([EquivBugState.EquivStateOpen, EquivBugState.EquivStateOpenAlt]);

const CLOSED_STATES = new Set<number>([
    EquivBugState.EquivStateClosed,
    EquivBugState.EquivStateClosedAlt,
    EquivBugState.EquivStateClosedRejected,
    EquivBugState.EquivStateClosedFinal,
]);

const FINAL_STATES = new Set<number>([EquivBugState.EquivStateClosedFinal]);

export abstract class BugStateEntity extends BugStateGeneratedEntity {
    get isKindOfOpen(): boolean {
        return OPEN_STATES.has(this.equivBugState);
    }

    get isKindOfClosed(): boolean {
        return CLOSED_STATES.has(this.equivBugState);
    }

    get isKindOfFinal(): boolean {
        return FINAL_STATES.has(this.equivBugState);
    }
}
